import React from 'react';
import {connect} from "react-redux";
import PropTypes from 'prop-types';

import UserFieldElement from '../../../reusable/UserFieldElement';
import UserFieldDataType from "../../../../utils/enums/UserFieldDataTypeEnum";

import {NotificationManager} from "react-notifications";
import {confirm} from "../../../../utils/confirmDialog";
import * as AdminActions from "../../../../actions/admin";

class SettingsKilometers extends React.Component {

    static propTypes = {
        section: PropTypes.object.isRequired,
        sectionNo: PropTypes.string.isRequired,
        editMode: PropTypes.bool.isRequired,
        isDDB: PropTypes.bool.isRequired,
        isSection: PropTypes.bool.isRequired,
        isClub: PropTypes.bool.isRequired,
        setAllowNew: PropTypes.func.isRequired,
    };

    static defaultProps = {
        editMode: false,
    };

    constructor(props) {
        super(props);
        this.state = {
            priceType: null,
            editIx: null,
            KM: '0',
            Faktor: '0',
            factorPairsLoaded: false,
        }
        this.props.setAllowNew(true);
    }

    componentDidMount(props) {
        this.props.dispatch(AdminActions.getKilometers(()=>{
            this.state = Object.assign(this.state, {factorPairsLoaded: true});
            this.forceUpdate()
        }));
    }

    componentWillReceiveProps(nextProps) {

    }

    fields = [];
    render() {
        if (!this.state.factorPairsLoaded){
            return null
        }

        return <div className={"form-page settings-kilometers " + (this.state.editIx !== null ? "editable" : "read-only")}>
            <div className={"content"}>
                <div className={"inner-content"}>
                    <table className="data-table">
                        <thead>
                        <tr>
                            <th>KM</th>
                            <th>Faktor</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.state.KM !== null ? this.props.admin.kmFactors.concat(this.state.editIx === 'new/new' ? [{KM: 'new', Faktor: 'new'}] : []).map(factorPair => <tr key={factorPair.KM + '/' + factorPair.Faktor} id={'row-' + factorPair.KM + '-' + factorPair.Faktor}>
                            <td>{
                                this.state.editIx === factorPair.KM + '/' + factorPair.Faktor ? <UserFieldElement dataType={UserFieldDataType.int} placeholder="" className="field75" containerClassName="display-inline-block"
                                                                                                                name="KM" id="KM" value={this.state.KM}
                                                                                                                autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                                                                                onChange={this.onStandardFieldChange}
                                                                                                                ref={instance => { this.fields[0] = instance; }}
                                /> : factorPair.KM.toString()
                            }</td>
                            <td>{
                                this.state.editIx === factorPair.KM + '/' + factorPair.Faktor ? <UserFieldElement dataType={UserFieldDataType.float} placeholder="" className="field100" containerClassName="display-inline-block"
                                                                                                                name="Faktor" id="Faktor" value={this.state.Faktor}
                                                                                                                autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                                                                                onChange={this.onStandardFieldChange}
                                                                                                                ref={instance => { this.fields[1] = instance; }}
                                /> : factorPair.Faktor.toString().replace('.',',')
                            }</td>
                            <td>{
                                this.state.editIx === factorPair.KM + '/' + factorPair.Faktor ? [
                                    <i key={0} className="fa fa-save clickable" title="Gem præmie" onClick={this.saveRow}/>,
                                    <i key={1} className="fa fa-undo clickable" title="Annuller" onClick={this.cancelEdit}/>
                                ] : [
                                    <i key={0} className={"fa fa-pencil " + (this.state.editIx === null ? 'clickable' : 'disabled')} title="Rediger række" onClick={() => {
                                        if (this.state.editIx === null){
                                            this.props.setAllowNew(false)
                                            this.setState({
                                                KM: factorPair.KM.toString(),
                                                Faktor: factorPair.Faktor.toString().replace('.',','),
                                                oldKM: factorPair.KM,
                                                editIx: factorPair.KM + '/' + factorPair.Faktor,
                                            });
                                        }
                                    }}/>,
                                    <i key={1}
                                       className={"fa fa-trash " + (this.state.editIx === null ? 'clickable' : 'disabled')} title="Slet præmie" onClick={() => {
                                        if (this.state.editIx === null) confirm("Slet", <span>Ønsker du at slette faktoren for <b>{factorPair.KM} KM</b>?</span>, () => {
                                            this.props.dispatch(AdminActions.deleteKilometer(factorPair.KM,() => {
                                                NotificationManager.success(`Tillæg for ${factorPair.KM} KM er slettet.`, "Sletning", 4000);
                                            }));
                                        });
                                    }}/>
                                ]
                            }</td>
                        </tr>) : null}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    }

    onStandardFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.value});
    };
    
    allInputValid = () => {
        let result = true;
        this.fields.forEach((field, ix) => {
            if (field && !field.isValid()) result = false;
        });
        return result;
    };

    saveRow = () => {
        if (this.allInputValid()) {
            const entity = {
                KM: this.state.Antal === '' ? 0 : Number(this.state.KM),
                Faktor: this.state.Vaerdi === '' ? 0 : Number(this.state.Faktor.replace(',', '.')),
            };
            if (this.state.editIx === 'new/new') {
                this.props.dispatch(AdminActions.createKilometer(entity, () => {
                    NotificationManager.success(`Tillæg for ${this.state.KM} KM (faktor ${this.state.Faktor}) er oprettet.`, "Oprettelse", 4000);
                    this.setState({editIx: null});
                    setTimeout(function () {
                        const currentRow = document.getElementById("row-" + this.state.KM + "-" + this.state.Faktor.replace(',','.'));
                        currentRow.scrollIntoView(false);
                    }.bind(this));
                }));
            } else this.props.dispatch(AdminActions.updateKilometer(this.state.oldKM,  entity, () => {
                NotificationManager.success(`Tillæg for ${this.state.KM} KM (faktor ${this.state.Faktor}) er opdateret.`, "Opdatering", 4000);
                this.setState({editIx: null});
                setTimeout(function () {
                    const currentRow = document.getElementById("row-" + this.state.KM + "-" + this.state.Faktor.replace(',','.'));
                    currentRow.scrollIntoView(false);
                }.bind(this));
            }));
        } else {
            this.fields.forEach((field) => {
                field.setState({visited: true});
            });
        }
        this.props.setAllowNew(true);
    }

    createNew = () => {
        this.props.setAllowNew(false);
        this.setState({
            KM: '',
            Faktor: '',
            editIx: 'new/new'
        });
        setTimeout(function () {
            const content = document.getElementById("tab-page");
            content.scrollTop = content.scrollHeight;
        });
    };

    cancelEdit = () => {
        this.setState({editIx: null});
        this.props.setAllowNew(true);
    };
}

const mapStateToProps = (state) => ({
    admin: {
        kmFactors: state.admin.kmFactors,
    }
});

export default connect(mapStateToProps, null, null, {withRef: true})(SettingsKilometers);



// WEBPACK FOOTER //
// ./src/client/src/components/pages/settings/subPages/SettingsKilometers.js